import { render, staticRenderFns } from "./homeBtn.vue?vue&type=template&id=602bba24"
import script from "./homeBtn.vue?vue&type=script&lang=js"
export * from "./homeBtn.vue?vue&type=script&lang=js"
import style0 from "./homeBtn.vue?vue&type=style&index=0&id=602bba24&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports